import type { RoleId } from './permissions.js';

/**
 * Employee badges: the West Coast Wireless card with the person's name, job and store city. An
 * uploaded badge is shown as it is; for everyone else STORE OS draws one in the same design.
 */

/** The job printed on a badge STORE OS draws. */
export const BADGE_TITLES: Record<RoleId, string> = {
  owner: 'Owner',
  district_manager: 'District Manager',
  manager: 'Manager',
  sales: 'Sales Representative',
  technician: 'Technician',
};

/** The name on a drawn badge: the first name, plus the last name's first letter ("Moe K."). */
export function badgeName(first: string, last: string): string {
  const l = (last ?? '').trim();
  return `${(first ?? '').trim()}${l ? ` ${l[0]}.` : ''}`;
}

/** What a badge needs: the uploaded picture, or what to draw. */
export interface BadgeInfo {
  badge_url: string | null;
  badge_name: string;
  /** "Oakland, CA": the store the person works at. */
  badge_city: string | null;
}
